import React from 'react';
import before1 from '../images/before1.jpg';
import before2 from '../images/before2.jpg';
import before3 from '../images/before3.jpg';
import before4 from '../images/before4.jpg';
import before5 from '../images/before5.jpg';
import after1 from '../images/after1.jpg';
import after2 from '../images/after2.jpg';
import after3 from '../images/after3.jpg';
import after4 from '../images/after4.jpg';
import { motion } from 'framer-motion';

const Report = () => {
  const fadeInUp = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
  };

  // Arrays to hold before and after images
  const beforeImages = [after1, before2, before3, before4, before5];
  const afterImages = [before1, after2, after3, after4];

  return (
    <section className="container py-5" aria-labelledby="case-report-title">
      {/* Header Section */}
      
      {/* Before and After Section */}
      <div className="row g-4">
        {/* Before Test */}
        <motion.div
          className="col-md-6"
          initial="hidden"
          whileInView="visible"
          variants={fadeInUp}
          viewport={{ once: true, amount: 0.2 }}
        >
          <div className="card h-100 shadow-sm border-0">
            <div className="card-body text-center">
              <h2 className="h4 fw-semibold mb-3">Before Treatment</h2>
              <div className="d-flex flex-wrap justify-content-center gap-2">
                {beforeImages.map((image, index) => (
                  <img
                    key={`before-${index}`}
                    src={image}
                    alt={`Before Treatment ${index + 1}`}
                    className="img-fluid rounded"
                    style={{ maxWidth: '150px', height: 'auto' }}
                  />
                ))}
              </div>
            </div>
          </div>
        </motion.div>

        {/* After Test */}
        <motion.div
          className="col-md-6"
          initial="hidden"
          whileInView="visible"
          variants={fadeInUp}
          viewport={{ once: true, amount: 0.2 }}
        >
          <div className="card h-100 shadow-sm border-0">
            <div className="card-body text-center">
              <h2 className="h4 fw-semibold mb-3">After Treatment</h2>
              <div className="d-flex flex-wrap justify-content-center gap-2">
                {afterImages.map((image, index) => (
                  <img
                    key={`after-${index}`}
                    src={image}
                    alt={`After Treatment ${index + 1}`}
                    className="img-fluid rounded"
                    style={{ maxWidth: '150px', height: 'auto' }}
                  />
                ))}
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Report;